import { Box, Flex } from 'reflexbox';

import { Avatar, Label, Subheading } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';

import RoleEdge from './RoleEdge';

export default function Me(props: { user: graphql.User }) {
	const { localize } = useLocalize();

	return (
		<Flex>
			<Box flexGrow={0} flexShrink={0} width={200} />
			<Box flexGrow={1} flexShrink={1} />
			<Flex
				flexGrow={0}
				flexShrink={0}
				width={180 * 2 + 8}
				flexDirection="column"
				alignItems="center"
			>
				<Box mb={3}>{props.user ? <Avatar user={props.user} /> : <Avatar.Skeleton />}</Box>
				<Flex alignItems="center" flexDirection="column">
					<Box mb={1}>
						{props.user ? (
							<Subheading textAlign="center">
								{props.user.firstName} {props.user.lastName}
							</Subheading>
						) : (
							<Subheading.Skeleton width={100} />
						)}
					</Box>
					{props.user ? (
						<Label textAlign="center">
							{localize(props.user.jobPositions[0]?.jobTitle.title ?? [])?.text ?? '-'}
						</Label>
					) : (
						<Label.Skeleton width={75} />
					)}
				</Flex>
				<Box style={{ position: 'relative' }}>
					<RoleEdge from={[-32, -72]} to={[-94, 64 - 8]} />
					<RoleEdge from={[32, -72]} to={[94, 64 - 8]} />
				</Box>
			</Flex>
			<Box flexGrow={1} flexShrink={1} />
		</Flex>
	);
}
